import Modal from "../../../../../components/portal/Modal";
import { formatDate } from "../../../../../functions/dateTime/formatDate";
import VehicleCylinderConditions from "./VehicleCylinderConditions";

const VehicleHistoryDialog = ({
  setActiveDialog,
  dialogDetails,
  handleImageView,
}) => {
  const { type, data } = dialogDetails;
  const dialogStyle = `view-dialog-content absolute-center-align ${
    data.length === 1 ? "max-w-lg" : "max-w-5xl"
  }`;
  const dialogCardStyle = `p-2 ${
    data.length === 1 ? "w-full" : "w-full md:w-1/2"
  }`;

  return (
    <Modal onClose={() => setActiveDialog(null)} modalWidth={dialogStyle}>
      <h4 className="cy-vehicle-history-dialog-heading">
        {type}ed Cylinder Details ({data.length})
      </h4>
      <div className="cy-vehicle-history-dialog-h">
        {data.map((item, ind) => {
          return (
            <div key={ind} className={dialogCardStyle}>
              <div key={ind} className="cy-vehicle-history-dialogCard ">
                <div className="flex justify-between p-2 border-b-1 border-border-lg5">
                  <p>Cylinder No. {item.cylinderNumber}</p>
                  <p>Size: {item.cylinderSize}kg</p>
                </div>
                <div className="p-2">
                  <div className="flex justify-between">
                    <h4 className="text-dark-blue font-figtreeMedium">
                      Dispatched
                    </h4>
                    <p className="text-lb5 text-sm">
                      {formatDate(item.dispatchTime)}
                    </p>
                  </div>
                  <div className="cy-vehicle-history-dialogCardBlueBox">
                    <p className="text-lb5"> From : {item.fromStationName}</p>
                    <p className="text-sm"> (By: {item.dispatchedByName})</p>
                  </div>
                  {item.receivedAtStationName && (
                    <>
                      <div className="flex justify-between pt-2">
                        <h4 className="text-dark-blue font-figtreeMedium">
                          Received
                        </h4>
                        <p className="text-lb5 text-sm">
                          {formatDate(item.receiveTime)}
                        </p>
                      </div>
                      <div className="cy-vehicle-history-dialogCardBlueBox">
                        <p className="text-lb5">
                          From : {item.receivedAtStationName}
                        </p>
                        <p className="text-sm">(By : {item.receivedByName})</p>
                      </div>
                    </>
                  )}
                  <VehicleCylinderConditions
                    data={item}
                    handleImageView={handleImageView}
                  />
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </Modal>
  );
};

export default VehicleHistoryDialog;
